<template>
  <div
    class="opportunity-status-badge"
    :style="{ backgroundColor: color }"
    :class="{ 'is-dark': isColorDark, 'is-actionable': isActionable, 'is-small': isSmall }"
  >
    <div class="opportunity-status-badge__text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'BaseStatusBadge',
  props: {
    text: String,
    color: String,
    // Adds the hover affordance used when the badge itself opens a menu,
    // same idea as <BaseGridTag> is-actionable.
    isActionable: {
      type: Boolean,
      default: false,
    },
    // The tags' height (20px): among them, or in a phone row's title.
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isColorDark() {
      // Convert the color to RGB
      const hex = this.color.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      // Calculate the brightness (using the luminance formula)
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness < 128; // Threshold for dark color
    },
  },
};
</script>

<style lang="scss">
.opportunity-status-badge {
  align-items: center;
  border-radius: $border-radius-small;
  color: $color-normal;
  display: flex !important;
  max-width: 150px;
  padding: 4px 8px;
  user-select: none;
  width: min-content;

  &.is-dark {
    color: $color-white;
  }

  &.is-actionable {
    cursor: pointer;
    transition: filter 150ms ease-in;

    &:hover {
      filter: brightness(0.94);
    }
  }

  &__text {
    font-size: $font-size-small;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.is-small {
    padding: 2px 8px;

    .opportunity-status-badge__text {
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>
